import Link from 'next/link'
import { FC } from 'react'

import { NavAccordion } from '@/widgets/Navigation/NavAccordion'

import { isSubDomain } from '@/shared/lib/utils/url/isSubDomainUrl'
import { Col, Row } from '@/shared/ui/Grid'
import { Text } from '@/shared/ui/Typography'

import maxIcon from '../assets/max-icon.svg'
import telegramIcon from '../assets/telegram-icon.svg'
import vkIcon from '../assets/vk-icon.svg'

import { ContactDrawer } from './components/ContactDrawer'
import { FooterBottom } from './components/footer-bottom/FooterBottom'
import { FooterPageList } from './components/FooterPageList/FooterPageList'
import { SocialItem } from './components/FooterShopInfo/components/SocialItem/SocialItem'
import { FooterShopInfo } from './components/FooterShopInfo/FooterShopInfo'
import { footerData, menuData, subDomainFooterPage, subDomainMenuData } from './data'

import styles from './Footer.module.scss'

export const Footer: FC = () => {
	const isSubDomainSite = typeof window !== 'undefined' ? isSubDomain(window.location.href) : false
	const menuItems = isSubDomainSite ? subDomainMenuData : menuData
	const footerItems = isSubDomainSite ? subDomainFooterPage : footerData
	return (
		<footer className={styles.footer}>
			<div className={styles.content}>
				<Row gutter={[0, 32]}>
					<Col xs={0} sm={24} md={18} xl={12}>
						<FooterPageList footerPage={footerItems} />
					</Col>
					<Col span={24} md={0}>
						{menuItems.map(navSection => (
							<NavAccordion navSection={navSection} key={navSection.title} />
						))}
					</Col>
					<Col span={24} md={0}>
						<Link prefetch={false} href="tel:8(812)318-38-38">
							<Text as="span" weight="medium" color="#fff">
								8 (812) 318-38-38
							</Text>
							<Text color="#828282" style={{ marginBottom: '32px' }}>
								ежедневно с 10:00 до 22:00
							</Text>
						</Link>{' '}
						<ContactDrawer forFooter />
					</Col>
					<Col span={24} xs={24} md={{ span: 6 }} xxl={{ span: 8 }}>
						<Text weight="medium" color={`#fff`} style={{ marginBottom: '16px' }}>
							Подписаться на нас
						</Text>
						<div className={styles.iconList}>
							{/* Social link item */}
							<SocialItem href="https://vk.com/iport_apple" iconId={vkIcon} title="Мы в Вконтакте" />

							<SocialItem href="https://t.me/iport_apple" iconId={telegramIcon} title="Мы в Telegram" />
							<SocialItem href="https://max.ru/iport_apple" iconId={maxIcon} title="Мы в MAX" />
						</div>
					</Col>
					<Col span={0} md={24} xl={6} xxl={{ span: 4 }}>
						<FooterShopInfo />
					</Col>
					<Col span={24} order={4}>
						<FooterBottom />
					</Col>
				</Row>
			</div>
		</footer>
	)
}
